/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aitextpostpromptplaceholder4Inputs */

const en_aitextpostpromptplaceholder4 = /** @type {(inputs: Aitextpostpromptplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Weekend brunch special, live music from 10am`)
};

const de_aitextpostpromptplaceholder4 = /** @type {(inputs: Aitextpostpromptplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Wochenend-Brunch, Live-Musik ab 10 Uhr`)
};

/**
* | output |
* | --- |
* | "e.g. Weekend brunch special, live music from 10am" |
*
* @param {Aitextpostpromptplaceholder4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aitextpostpromptplaceholder4 = /** @type {((inputs?: Aitextpostpromptplaceholder4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aitextpostpromptplaceholder4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aitextpostpromptplaceholder4(inputs)
	return de_aitextpostpromptplaceholder4(inputs)
});
export { aitextpostpromptplaceholder4 as "aiTextPostPromptPlaceholder" }